module.exports = __webpack_public_path__ + "static/img/2.534c952.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/2.jpg
// module id = 0Csf
// module chunks = 1